export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/55d4bc8973c06606262cde4bad779808.jpg"
          alt="Inherited Home"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          We Buy Inherited Homes<br />in El Paso, Texas
        </h1>
        
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          Dealing with an inherited property? We handle everything from paperwork to closing, making the process simple and stress-free.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:+1-915-206-5814"
            className="px-8 py-4 bg-teal-600 hover:bg-teal-700 text-white text-lg font-bold rounded-lg transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call (915) 206-5814
          </a>
          <a
            href="#process"
            className="px-8 py-4 bg-white hover:bg-gray-100 text-gray-900 text-lg font-bold rounded-lg transition-all shadow-xl whitespace-nowrap cursor-pointer"
          >
            Learn Our Process
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-xl">
            <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-file-text-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">We Handle Paperwork</h3>
            <p className="text-sm text-gray-600">All legal documents and probate matters taken care of</p>
          </div>

          <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-xl">
            <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Fast Cash Offers</h3>
            <p className="text-sm text-gray-600">Get a fair cash offer within 24 hours</p>
          </div>

          <div className="bg-white/95 backdrop-blur-sm rounded-xl p-6 shadow-xl">
            <div className="w-14 h-14 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-home-smile-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Any Condition</h3>
            <p className="text-sm text-gray-600">No repairs or cleaning needed before selling</p>
          </div>
        </div>
      </div>
    </section>
  );
}